<template>
  <input type="text" placeholder="Search..." />
</template>

<script>
export default {
  name: "Search"
};
</script>

<style lang="scss" scoped>
</style>
